import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import {
	LazyHorizontalOperationsOverviewNav,
	AsyncHorizontalOperationsOverviewNav,
} from '@atlassian/jira-operations-horizontal-nav/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getTeamsResource } from '@atlassian/jira-router-resources-eoc-overview/src/index.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { eocOverviewRoute } from '@atlassian/jira-router-routes-eoc-overview-routes/src/eocOverviewRoute.tsx';
import { opsMigrationHubLayout } from '@atlassian/jira-ops-settings-layout/src/index.tsx';
import { eocCommonResources } from '@atlassian/eoc-resources';
import { EocOverviewComponent, LazyOverviewPage } from './ui/index.tsx';

export const eocOverviewRouteEntry = createEntry(eocOverviewRoute, () => ({
	group: 'eoc',
	component: EocOverviewComponent,
	layout: opsMigrationHubLayout,

	resources: [
		...getNavigationResources(),
		getConsolidationStateResource(),
		getTeamsResource,
		...eocCommonResources(),
	],

	navigation: {
		menuId: MENU_ID.HOME,
		horizontal: AsyncHorizontalOperationsOverviewNav,
	},

	forPaint: [LazyAtlassianNavigation, LazyHorizontalOperationsOverviewNav, LazyOverviewPage],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-eoc-overview-entries/src/eocOverviewRouteEntry.tsx',
			whichExportToUse: 'eocOverviewRouteEntry',
		},

		enabled: true,
	},
}));
